import { type CSSProperties } from "react";
import { Input } from "@carry/ui";

interface SearchInputProps {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  pending?: boolean;
  width?: number | string;
  ariaLabel?: string;
}

export function SearchInput({
  value,
  onChange,
  placeholder = "検索",
  pending = false,
  width = 260,
  ariaLabel,
}: SearchInputProps) {
  const wrapper: CSSProperties = {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    width,
  };
  return (
    <div style={wrapper}>
      <Input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        className="h-[28px] w-full text-xs"
        style={{ padding: "0 56px 0 10px" }}
      />
      <div
        style={{
          position: "absolute",
          right: 6,
          top: 0,
          bottom: 0,
          display: "flex",
          alignItems: "center",
          gap: 4,
          pointerEvents: "none",
        }}
      >
        {pending && (
          <span
            aria-hidden="true"
            style={{
              width: 10,
              height: 10,
              border: "1.5px solid var(--rule-soft)",
              borderTopColor: "var(--accent)",
              borderRadius: "50%",
              animation: "cp-spin 0.8s linear infinite",
            }}
          />
        )}
        {value && (
          <button
            type="button"
            onClick={() => onChange("")}
            aria-label="検索をクリア"
            title="クリア"
            style={{
              pointerEvents: "auto",
              width: 18,
              height: 18,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: 0,
              borderRadius: 2,
              background: "transparent",
              color: "var(--ink-3)",
              cursor: "pointer",
              fontSize: 14,
              lineHeight: 1,
            }}
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
}
